import * as next from '../../../types/next'
import type { InputCalculatorOptionDevice } from '../../../utils'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'
import { newId, sanitizeUnit } from '../utils'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.InputCalculatorBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.INPUT_CALCULATOR_CONTROL) {
    throw new Error('Expected a valid InputCalculator control')
  }

  const deviceUnit = upDeviceUnit(uischema.options?.deviceUnit)

  return {
    type: next.BLOCK_TYPE.INPUT_CALCULATOR,
    required: false, // can never be required
    settings: {
      ...upCommonSettings(uischema),
      allowOther: uischema.options?.allowOther,
      items: upDeviceOptions(uischema.options?.deviceOptions),
      deviceUnit,
      digitsAfterDecimalPoint: uischema.options?.digitsAfterDecimalPoint ?? 2
    }
  }
}

export const upDeviceUnit = (value: string | null | undefined): next.UNITS => {
  return sanitizeUnit(value, next.UNITS.noUnit)
}

const upDeviceOptions = (
  deviceOptions: InputCalculatorOptionDevice[]
): Record<next.InputCalculatorItemId, next.InputCalculatorItem> => {
  const items: Record<next.InputCalculatorItemId, next.InputCalculatorItem> = {}

  deviceOptions.forEach((deviceOption, idx) => {
    const { preSelect, value, factor } = deviceOption
    const _id = newId<next.InputCalculatorItemId>()

    const customMappings =
      factor?.preset === 'custom'
        ? factor.custom_mappings?.map((customMapping: any) => {
            return customMapping
          })
        : undefined
    const item: next.InputCalculatorItem = {
      orderIndex: idx,
      id: _id,
      preSelect: Boolean(preSelect),
      name: value,
      factor:
        factor && factor.preset
          ? factor.preset === next.DEVICE_OPTION_FACTOR_PRESET.CUSTOM
            ? {
                preset: factor.preset,
                customMappings: customMappings ?? []
              }
            : {
                preset: factor.preset
              }
          : undefined
    }

    items[_id] = item
  })

  return items
}
